var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cell-personal-account",
      class: { "cell-personal-account_disabled": !_vm.canEdit },
      on: {
        click: function ($event) {
          _vm.canEdit && (_vm.isShowPersonalAccountTransactionModal = true)
        },
      },
    },
    [
      _c("m-personal-account-transactions", {
        attrs: {
          active: _vm.isShowPersonalAccountTransactionModal,
          record: _vm.record,
          personalReasons: _vm.personalReasons,
          "calculation-type": _vm.calculationType,
        },
        on: {
          close: function ($event) {
            _vm.isShowPersonalAccountTransactionModal = false
          },
          submitPersonalAccountTransactionValue:
            _vm.setPersonalAccountTransactionValue,
        },
      }),
      _c(
        "div",
        {
          staticClass: "cell-personal-account-value",
          class: {
            "cell-personal-account-value-grey":
              _vm.record.personal_account_transactions.value === 0,
            "cell-personal-account-value-green":
              _vm.record.personal_account_transactions.value > 0,
            "cell-personal-account-value-red":
              _vm.record.personal_account_transactions.value < 0,
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.numberWithSpaces(
                  _vm.record.personal_account_transactions.value
                )
              ) +
              " "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }